<template lang="pug">
  .ds-apps-list(v-infinite-scroll="onLoadMore" infinite-scroll-disabled="disabledLoadingMore" infinite-scroll-distance="50")
    v-data-table(v-show="false" :headers="headers")
    app-table(
      :value="activeItems"
      :headers="headers"
      :list="list"
      itemKey="id"
      hide-default-footer
      :server-items-length="list.length"
      :loading="loading"
      :show-select="true"
      :single-select="false"
      :disabled-select="!isSelectedSchoolFilter"
      :mobile-breakpoint='NaN'
      :sort-by.sync="sortModel.by"
      :sort-desc.sync="sortModel.desc"
      @update:sort-desc="updateSorting"
      @input="selectActiveItems"
      hide-default-header
      class="app-table-new v-data-table theme--light"
    )
      template(v-slot:top)
        actions(
          :loading="loading"
          :disabled="!hasActiveItems"
          :activeItems="activeItems"
          @needToUpdate="needToUpdate"
        )
      template(v-slot:item="{item, select, isSelected, index}")
        item(
          :item="item"
          :index="index"
          :key="item.id"
          :isSelected="isSelected"
          :select="select"
          :activeItems="activeItems"
          :primaryPagination="primaryPagination"
          @click:link="clickItemLink"
          @needToUpdate="$emit('needToUpdate')"
        )
</template>

<script>
import ROUTE_NAMES from '@/app/admin/router/router-const'
import InfinityScroll from '@/components/global/infinityScroll.vue'
import SortModel from '../../core/drivingSchool-sortModel'

export default {
  name: 'DrivingSchoolPageApplicationsList',

  props: {
    list: Array,
    headers: Array,
    loading: Boolean,
    pagination: Object,
    primaryPagination: Object
  },

  data: () => ({
    activeItems: [],
    sortModel: null
  }),

  computed: {
    disabledLoadingMore() {
      if (!this.pagination) return true
      if (this.loading) return true
      if (!this.pagination.next) return true
      return false
    },

    hasActiveItems() {
      return !!(this.activeItems && this.activeItems.length)
    },

    isSelectedSchoolFilter() {
      return !!(this.$route.query && this.$route.query.driving_school)
    }
  },

  created() {
    this.initSortModel()
  },

  methods: {
    initSortModel() {
      this.sortModel = new SortModel(this.$route.query)
    },

    onLoadMore() {
      if (!this.pagination) return
      this.$emit('loadMore')
    },

    async updateSorting() {
      let data = this.sortModel.getApiData(this.$route.query)
      let ordering
      if (data.ordering.length) ordering = data.ordering
      this.$emit('change:sorting', ordering)
    },

    selectActiveItems(items) {
      this.activeItems = items.filter(item => !item.transaction)
    },

    resetActiveItems() {
      this.activeItems = []
    },

    needToUpdate() {
      this.resetActiveItems()
      this.$emit('needToUpdate')
    },

    async clickItemLink(item) {
      await this.$router.replace({
        name: ROUTE_NAMES.DRIVING_SCHOOLS_TRANSACTIONS,
        query: {
          page: 1,
          id: item?.transaction,
        }
      })
    }
  },

  watch: {
    '$route.query.driving_school'() {
      this.needToUpdate()
    }
  },

  components: {
    infinityScroll: InfinityScroll,
    appTable: () => import('@/components/global/GroupedTable.vue'),
    item: () => import('./SchoolApplicationListItem.vue'),
    actions: () => import('../../components/DrivingSchoolActions.vue')
  }
}
</script>

<style lang="scss">
@import '@/assets/scss/tableNew';

.app-table-new .v-data-table tbody tr td:first-child {
  width: 32px;
  height: 32px;
}

.ds-apps-list {
  min-height: 100vh;
}

.task-app-table {
  display: table;
  width: 100%;
}
</style>
